import { CHILE } from '../../constants'

const TelephoneFormatter = {
  format: (country, telephone) => {
    if (!telephone) return ''
    return CHILE.value === country ? telephone.slice(0,12).replace(/[^0-9+]+/g, '') : telephone.slice(0,9).replace(/\D+/g, '')
  },
}

export default TelephoneFormatter
